import React from 'react'
import { MuiThemeProvider } from '@material-ui/core'
import { greenTheme } from '../themes'

export const GreenThemeProvider = ({ children }) => (
  <MuiThemeProvider theme={greenTheme}>{children}</MuiThemeProvider>
)
